import type { CSSProperties } from 'react';
import { isNumber } from 'lodash-es';
import { Spacing } from '../constants/spacing';

export type SpacingType = {
  m?: keyof typeof Spacing | number;
  mt?: keyof typeof Spacing | number;
  mr?: keyof typeof Spacing | number;
  mb?: keyof typeof Spacing | number;
  ml?: keyof typeof Spacing | number;
  mx?: keyof typeof Spacing | number | 'auto';
  my?: keyof typeof Spacing | number;
  p?: keyof typeof Spacing | number;
  pt?: keyof typeof Spacing | number;
  pr?: keyof typeof Spacing | number;
  pb?: keyof typeof Spacing | number;
  pl?: keyof typeof Spacing | number;
  px?: keyof typeof Spacing | number;
  py?: keyof typeof Spacing | number;
};

export const spacingGenerator = (args: SpacingType): Array<CSSProperties> => {
  const styles: Array<CSSProperties> = [];

  // directional margin
  if (args.ml) styles.push({ marginLeft: `${isNumber(args.ml) ? args.ml : Spacing[args.ml]}rem` });
  if (args.mr) styles.push({ marginRight: `${isNumber(args.mr) ? args.mr : Spacing[args.mr]}rem` });
  if (args.mb) styles.push({ marginBottom: `${isNumber(args.mb) ? args.mb : Spacing[args.mb]}rem` });
  if (args.mt) styles.push({ marginTop: `${isNumber(args.mt) ? args.mt : Spacing[args.mt]}rem` });

  // horizontal margin
  if (args.mx) {
    if (args.mx === 'auto') {
      styles.push({ marginLeft: 'auto', marginRight: 'auto' });
    } else {
      styles.push({
        marginLeft: `${isNumber(args.mx) ? args.mx : Spacing[args.mx]}rem`,
        marginRight: `${isNumber(args.mx) ? args.mx : Spacing[args.mx]}rem`,
      });
    }
  }

  if (args.my) {
    styles.push({
      marginTop: `${isNumber(args.my) ? args.my : Spacing[args.my]}rem`,
      marginBottom: `${isNumber(args.my) ? args.my : Spacing[args.my]}rem`,
    });
  }

  // all direction margin
  if (args.m) {
    styles.push({ margin: `${isNumber(args.m) ? args.m : Spacing[args.m]}rem` });
  }

  // directional padding
  if (args.pl) styles.push({ paddingLeft: `${isNumber(args.pl) ? args.pl : Spacing[args.pl]}rem` });
  if (args.pr) styles.push({ paddingRight: `${isNumber(args.pr) ? args.pr : Spacing[args.pr]}rem` });
  if (args.pb) styles.push({ paddingBottom: `${isNumber(args.pb) ? args.pb : Spacing[args.pb]}rem` });
  if (args.pt) styles.push({ paddingTop: `${isNumber(args.pt) ? args.pt : Spacing[args.pt]}rem` });

  // horizontal padding
  if (args.px) {
    styles.push({
      paddingLeft: `${isNumber(args.px) ? args.px : Spacing[args.px]}rem`,
      paddingRight: `${isNumber(args.px) ? args.px : Spacing[args.px]}rem`,
    });
  }

  if (args.py) {
    styles.push({
      paddingTop: `${isNumber(args.py) ? args.py : Spacing[args.py]}rem`,
      paddingBottom: `${isNumber(args.py) ? args.py : Spacing[args.py]}rem`,
    });
  }

  if (args.p) {
    styles.push({ padding: `${isNumber(args.p) ? args.p : Spacing[args.p]}rem` });
  }

  return styles;
};
